import _ from 'lodash';
import resize from '../action/resize';
import getScrollTop from './getScrollTop';
import pubSub from './pubSub';

export function scrollListener() {
  let latestKnownScrollY = 0;

  function updateScrollTop() {
    pubSub.publish('scroll', latestKnownScrollY);
  }

  function onScroll() {
    latestKnownScrollY = getScrollTop();
    updateScrollTop();
  }

  window.addEventListener('scroll', onScroll, false);

  // call updateScrollTop to get initial scrollTop
  updateScrollTop();
}

export function resizeListener(dispatch, delay) {
  const body = document.getElementsByTagName('body')[0];

  function updateWindowSize() {
    const width = window.innerWidth || document.documentElement.clientWidth || body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight || body.clientHeight;

    dispatch(resize({ width, height }));
  }

  window.addEventListener('resize', _.throttle(updateWindowSize, delay, { leading: false }));

  // call updateWindowSize to get initial window size
  updateWindowSize();
}



// WEBPACK FOOTER //
// ./src/util/eventListeners.js